<div class="logoutDetails">
  <span (click)="openModal()"
    >{{ "header.welcome" | cxTranslate }} {{ name }} -
    {{ "header.logout" | cxTranslate }}</span
  >
</div>
